import { computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import Configuracao from '../../util/Configuracao';
import ReactComponent from '../ReactComponent';
import CodigoDecisao from './CodigoDecisao';
import MovimentoCNJ from './MovimentoCNJ';

class CodDecisaoMovCNJ extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            origemPJe: computed
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    get origemPJe() {
        return this.registro && this.registro.processo.origem === Configuracao.ORIGEM_PJE;
    }

    render() {
        return this.origemPJe ? (
            <MovimentoCNJ registro={this.registro} />
        ) : (
            <CodigoDecisao
                registro={this.registro}
                id={this.observableProps.id}
            />
        );
    }
}

export default inject('stores')(observer(CodDecisaoMovCNJ));
